"use client"

import React, { useState, useEffect } from 'react';
 
const labelsNames = [
    "oportunities-investment-oportunities",
    "oportunities-investment-oportunities-analysis",
    "oportunities-investment-oportunities-analysis-2",
    "oportunities-investment-oportunities-analysis-first-check",
    "oportunities-investment-oportunities-analysis-second-check",
    "oportunities-investment-oportunities-analysis-third-check",
    "oportunities-investment-oportunities-analysis-fourth-check",
];
 
export default function PasosSeguirEmpresa({
    labels,
    lang,
  }: {
    labels: any;
    lang: any;
  }) {
 
    return (
        <div className="px-6 mt-10 bg-[#E0EDF3]">
          <div className="h-auto px-12 py-16 max-w-screen-xl mx-auto">
            <div className="flex flex-col gap-5 justify-start mb-20">
              <h2 className="text-[#016391] font-bold">
                {labels.oportunitiesInvestmentOportunities}
              </h2>
              <p className="text-primary text-3xl md:pr-80">
                {labels.oportunitiesInvestmentOportunitiesAnalysis2}
              </p>
            </div>
            <div className="flex flex-col gap-5">
              <div className="flex md:flex-row flex-col justify-center gap-4">
                <div className="md:w-[40%] w-[100%] flex justify-center items-center">
                  <button className="w-[100%] bg-[#035278] px-20 py-2 rounded-full text-2xl font-bold text-white">1</button>
                </div>
                <div className="md:w-[60%] w-[100%] border-b-4 border-[#99C0D3] pb-2">
                  <div>
                    <p className="md:text-end text-center font-regular text-lg">
                      <span dangerouslySetInnerHTML={{__html: labels.oportunitiesInvestmentOportunitiesAnalysisFirstCheck}}></span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex md:flex-row flex-col justify-center gap-4">
                <div className="md:w-[40%] w-[100%] flex justify-center items-center">
                  <button className="w-[85%] bg-[#2E7290] px-20 py-2 rounded-full text-2xl font-bold text-white">2</button>
                </div>
                <div className="md:w-[60%] w-[100%] border-b-4 border-[#99C0D3] pb-2">
                  <div>
                    <p className="md:text-end text-center font-regular text-lg">
                      <span dangerouslySetInnerHTML={{__html: labels.oportunitiesInvestmentOportunitiesAnalysisSecondCheck}}></span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex md:flex-row flex-col justify-center gap-4">
                <div className="md:w-[40%] w-[100%] flex justify-center items-center">
                  <button className="w-[70%] bg-[#719EB4] px-20 py-2 rounded-full text-2xl font-bold text-white">3</button>
                </div>
                <div className="md:w-[60%] w-[100%] border-b-4 border-[#99C0D3] pb-2">
                  <div>
                    <p className="md:text-end text-center font-regular text-lg">
                      <span dangerouslySetInnerHTML={{__html: labels.oportunitiesInvestmentOportunitiesAnalysisThirdCheck}}></span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex md:flex-row flex-col justify-center gap-4">
                <div className="md:w-[40%] w-[100%] flex justify-center items-center">
                  <button className="w-[55%] bg-[#A3C2D1] px-18 py-2 rounded-full text-2xl font-bold text-white">4</button>
                </div>
                <div className="md:w-[60%] w-[100%] border-b-4 border-[#99C0D3] pb-2">
                  <div>
                    <p className="md:text-end text-center font-regular text-lg">
                      <span dangerouslySetInnerHTML={{__html: labels.oportunitiesInvestmentOportunitiesAnalysisFourthCheck}}></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>  
    );
}
 
function setLabels(labelsIn: any, lang: string) {
    const labels: any = {};
    Object.keys(labelsIn).forEach((key) => {
        labels[key] = labelsIn[key][lang === 'en' ? 0 : 1];
    });
    return labels;
}